/**
 * Il numerino con il conteggio (ordini da pagare, fatture rifiutate…), accanto a una voce di menù.
 *
 * Sta in un file suo perché la disegnano entrambe le sidebar - struttura e
 * superadmin - e in più punti ciascuna, uno per ogni livello del menù. Finché
 * era ricopiata riga per riga in sei posti, "Richieste" era rimasta indietro: il
 * conteggio le arrivava, ma il ramo che disegna le voci senza sottomenù non
 * guardava affatto il badge.
 */
export const BadgeCount = ({ count }) => {
    if (!count || count <= 0) return null;

    // Stile in CSS (.sid-count-badge): piccolo, sfondo salmone chiaro
    return <span className="sid-count-badge">{count}</span>;
};

export default BadgeCount;
